import React, { FormEventHandler, BaseSyntheticEvent } from "react";
import {
  FieldValues,
  SubmitHandler,
  SubmitErrorHandler,
  UseFormGetValues,
} from "react-hook-form";

type FormWizardFormWrapperProps = {
  children: React.ReactNode;
  onSubmit: (data: any, e?: BaseSyntheticEvent, isValid?: boolean) => void;
  handleSubmit: (
    onValid: SubmitHandler<FieldValues>,
    onInvalid: SubmitErrorHandler<any>
  ) => FormEventHandler<HTMLFormElement>;
  getValues: UseFormGetValues<any>;
  className?: string;
};

const FormWizardFormWrapper: React.FC<FormWizardFormWrapperProps> = ({
  children,
  onSubmit,
  handleSubmit,
  getValues,
  className = "",
}) => {
  return (
    <form
      noValidate
      className={`form-wizard-form-wrapper ${className}`}
      onSubmit={handleSubmit(
        (data, e) => onSubmit(data, e, true),
        (errors, e) => onSubmit(getValues(), e, false)
      )}
    >
      {children}
    </form>
  );
};

export default FormWizardFormWrapper;
